import { HgSupportedLanguage } from '@smg-real-estate/domus';
import {
  createRouter,
  createWebHistory,
  type RouteLocationNormalized,
  type Router,
} from 'vue-router';

import favouritesPageRoutes from '@/router/routes/FavouritesPageRoutes';
import loginCallbackPageRoutes from '@/router/routes/LoginCallbackPageRoutes';

import { setupRumViewTracking } from '@smg-real-estate/browser-rum/vue';
import { setLocaleBeforeRouteChange } from '../i18n-setup';

export default function createAppRouter(defaultLanguage: HgSupportedLanguage): Router {
  const router = createRouter({
    history: createWebHistory('/'),
    routes: [...favouritesPageRoutes, ...loginCallbackPageRoutes],
  });

  setupRumViewTracking(router);

  router.beforeEach(
    async (targetRoute: RouteLocationNormalized, _sourceRoute: RouteLocationNormalized, next) => {
      const locale = getLocale(targetRoute, defaultLanguage);
      await setLocaleBeforeRouteChange(locale);
      next();
    },
  );

  return router;
}

function getLocale(
  route: RouteLocationNormalized,
  defaultLanguage: HgSupportedLanguage,
): HgSupportedLanguage {
  return (route.params.locale || route.meta?.locale || defaultLanguage) as HgSupportedLanguage;
}
